<template>
  <div>
    <b-card no-body header="Default" class="mb-0">
      <div slot="header">
        <div class="float-left">
          <div class="mt-2">
            <b>{{ title }} </b>
          </div>
        </div>
        <div class="float-right">
          <b-button
            v-if="question_kind == 1 || question_kind == 4"
            @click="randomNumber"
            v-b-tooltip.hover
            :title="$lang.random_questions_tooltip"
            class="btn btn-lightgray ml-2 btn-secondary"
          >
            <span key="fa-random">
              <i class="fa fa-list-ol" aria-hidden="true"></i>
            </span>
          </b-button>
          <b-button
            @click="addOption"
            v-if="question_kind == 1 || question_kind == 4"
            v-b-tooltip.hover
            :title="$lang.add_questions_tooltip"
            class="btn btn-lightgray ml-2 btn-secondary"
          >
            <i class="fa fa-plus" aria-hidden="true"></i>
          </b-button>

          <b-button
            @click="addImgOption"
            v-if="question_kind == 1 || question_kind == 4"
            v-b-tooltip.hover
            :title="$lang.img_option_tooltip"
            class="btn btn-lightgray ml-2 btn-secondary"
          >
            <i class="far fa-image"></i>
          </b-button>
          <b-button
            @click="toggleModal()"
            v-if="question_kind == 1 || question_kind == 4"
            v-b-tooltip.hover
            :title="$lang.add_question_tooltip"
            class="btn btn-lightgray ml-2 btn-secondary"
          >
            <i class="fa fa-list-alt" aria-hidden="true"></i>
          </b-button>
          <b-button @click="toggleCollapse" variant="success" class="ml-2">
            <i aria-hidden="true" class="fa fa-angle-down fa-lg"></i>
          </b-button>
        </div>
      </div>
      <b-collapse v-model="isCollapse" class="p-2">
        <div v-if="question_kind == 1 || question_kind == 4">
          <b-col
            v-for="(option, key) in selectedArrayOptions"
            :key="key"
            class="my-1"
            cols="12"
            md="12"
            draggable="true"
            @dragover="onDragOver(option, key, $event)"
            @dragend="finishDrag(option, key, $event)"
            @dragstart="startDrag(option, $event)"
          >
            <QuestionOption
              :option="option"
              @removeItem="Selected"
              :key="key"
              @getItem="questionOptionItem"
            />
          </b-col>
        </div>

        <b-col v-if="question_kind == 2" class="my-2" cols="12">
          <b-overlay
            no-center
            :variant="`transparent`"
            :blur="`2px`"
            :show="isOverlay"
            :opacity="0.3"
          >
            <template v-slot:overlay><span class="d-none">icon</span></template>
            <b-form-input
              v-model="answer_number"
              @input="sendcaptionQuestion"
              :formatter="formatter"
            ></b-form-input>
          </b-overlay>
        </b-col>
      </b-collapse>
    </b-card>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="captionModal"
      size="xl"
      ok-only
      hide-header
    >
      <b-overlay :show="isLoading" rounded="sm" :opacity="0.5">
        <QuestionListOption
          @optionSelected="optionSelected"
          :selectedArrayOptions="selectedArrayOptions"
          :filterCatch="false"
        />
      </b-overlay>
      <template v-slot:modal-footer>
        <b-button
          variant="success"
          :disabled="Object.keys(hasItem).length == 0"
          @click="saveOptions"
        >
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>
        <b-button class="ml-2" size="md" variant="danger" @click="closeModal">
          {{ $lang.cancelButton }}
          <i class="fa fa-ban"></i>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="question_view_add"
      size="xl"
      ok-only
      hide-header
      hide-footer
    >
      <AddQuestionOption @cancel="cancelAddImgOption" @getId="getImg" />
    </b-modal>

    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="isRandomModal"
      size="xl"
      ok-only
      hide-header
      hide-footer
    >
      <RandomNumberForm
        ref="randomNumberForm"
        @cancel="cancelIsRandomModal"
        @addRandomOption="addRandomOption"
      />
    </b-modal>
  </div>
</template>

<script>
import QuestionListOption from "./questionListOption";
import QuestionOption from "./questionOption";
import AddQuestionOption from "@/modules/azmoon/views/question_option/addQuestionOption";
import RandomNumberForm from "@/modules/azmoon/views/from/randomNumberForm";
import { createPureDom } from "@/shared/utils";

export default {
  name: "question-options",
  inject: ["questionsOptionRepository"],
  components: {
    QuestionListOption,
    QuestionOption,
    AddQuestionOption,
    RandomNumberForm,
  },
  props: {
    titles: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    allowPaginate: {
      type: Boolean,
      default: false,
    },
    question_kind: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      captionModal: false,
      question_view_add: false,
      captionQuestion: "",
      isOverlay: false,
      isCollapse: true,
      answer_number: "",
      answer_description: "",
      hasItem: {},
      over: {}, // برای درک فایل‌ها
      dragFrom: {}, // برای درک فایل‌ها
      startLoc: 0, // برای درک فایل‌ها
      dragging: false, // برای درک فایل‌ها
      searchValue: "",
      perPage: 0,
      totalPages: 0,
      totalRows: 0,
      currentPage: 1,
      isLoading: false,
      questionOptions: [],
      selectedArrayOptions: [],
      arrayOptions: [],
      create_id: -1,
      isRandomModal: false,
    };
  },

  watch: {
    selectedArrayOptions(newValue) {
      this.selectedArrayOptions = newValue;
      this.$emit("arrayOptions", newValue);
    },
  },
  methods: {
    createPureDom,
    addRandomOption(items) {
      this.isCollapse = true;
      items.map((item) => {
        this.selectedArrayOptions.push(item);
      });
      this.cancelIsRandomModal();
    },
    cancelIsRandomModal() {
      this.isRandomModal = false;
    },
    randomNumber() {
      this.isRandomModal = true;
    },
    formatter(value) {
      let regx = /^-?\d*[.,]?\d{0,2}$/.test(value);
      if (regx) {
        return value;
      } else {
        return ``;
      }
    },
    questionOptionItem(item) {
      const index = this.selectedArrayOptions.indexOf(item);
      item.value = +item.value;
      this.selectedArrayOptions[index] = item;
      this.$emit("arrayOptions", this.selectedArrayOptions);
    },

    addImgOption() {
      this.isCollapse = true;
      this.question_view_add = true;
    },
    cancelAddImgOption() {
      this.question_view_add = false;
    },
    sendcaptionQuestion(item) {
      this.$emit("sendanswerQuestion", item);
    },
    optionSelected(item) {
      this.hasItem = item;
      this.Selected(item);
    },
    Selected(item) {
      let index = this.selectedArrayOptions.indexOf(item);
      if (index == -1) {
        this.selectedArrayOptions.push(item);
      } else {
        this.selectedArrayOptions.splice(index, 1);
      }
    },
    filterOptions(item) {
      this.optionObject = item;
      let data = this.questionOptions.map((x) => {
        if (x.id === item.id) {
          x.checked = true;
          return x;
        } else {
          x.checked = false;
          return x;
        }
      });
      this.options = data;
    },
    async saveOptions() {
      // این قسمت قبلا سرویس میزدیم ولی متوجه شدم اگه س
      this.closeModal();
    },
    closeModal() {
      this.captionModal = false;
    },
    addOption() {
      this.isCollapse = true;
      let item = {
        id: (this.create_id -= 1),
        option_description: "",
        option_group_id: null,
      };
      this.$emit("addOption", item);
      this.selectedArrayOptions.push(item);
    },
    paging(page) {
      this.currentPage = page;
      this.questionOptionsList();
    },
    toggleModal() {
      this.captionModal = true;
    },
    async questionOptionsList(item) {
      let params = {
        page: this.currentPage,
        search_txt: this.searchValue,
        is_enable: 1,
        empty_description: item,
        order_by: "id:desc",
      };
      try {
        this.isLoading = true;

        const response = await this.questionsOptionRepository.list(params);
        const { result } = response.data.data;
        let data = response.data.data;
        if (result) {
          this.questionOptions = result.map((x) => {
            let item = this.selectedArrayOptions.find((z) => z.id == x.id);
            if (item) {
              return {
                ...x,
                checked: true,
              };
            } else {
              return {
                ...x,
                checked: false,
              };
            }
          });

          this.totalRows = data.total;
          this.totalPages = data.total_pages;
          this.perPage = data.per_page;
          this.currentPage = data.current_page;
        }
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getImg(id) {
      let params = {
        id: [id],
      };
      const response = await this.questionsOptionRepository.list(params);
      const { data } = response.data;
      data.map((x) => {
        let correct_answer = false;
        return {
          correct_answer,
          ...x,
        };
      });
      this.selectedArrayOptions = [...this.selectedArrayOptions, ...data];
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    addCaption() {
      this.isCollapse = true;
    },
    // removeItem(item) {

    //   this.$emit("optionSelected", item)
    // },
    /**
     * @vuese
     *  برای درک فایل هی
     *  @arg  پارامتر فایل و اتفاقاات در فانکسن
     */

    startDrag(item, e) {
      this.startLoc = e.clientY;
      this.dragging = true;
      this.dragFrom = item;
    },
    /**
     * @vuese
     *  برای درک فایل هی
     *  @arg   پارامتر فایل ومکان فایل
     */
    reorder(data, index) {
      return data.slice(index).concat(data.slice(0, index));
    },

    finishDrag(item, pos) {
      this.selectedArrayOptions.splice(pos, 1);
      this.selectedArrayOptions.splice(this.over.pos, 0, item);
      this.over = {};
    },
    /**
     * @vuese
     *  برای درک فایل هی
     *  @arg   پارامتر فایل و اتفاقاات در فانکسنو مکان فایل
     */
    onDragOver(item, pos, e) {
      const dir = this.startLoc < e.clientY ? "down" : "up";
      setTimeout(() => {
        this.over = {
          item,
          pos,
          dir,
        };
      }, 50);
    },
  },
};
</script>
